import { Button, FormGroup, InputGroup } from '@blueprintjs/core'
// TODO - Documentar
import { useEffect, useState } from 'react'
import LockEyePasswordButton from '../../templates/password/LockEyePasswordButton'
import * as con from "../../GlobalConstants"
import { RefApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { checkPassword, setApplicationParameter } from '../../store/slices/applicationParametersSlice'
import { useDispatch } from 'react-redux'

function TransactionsDeleteDialog({title, deleteAction, cancelAction}) {

    const passwordStatus = RefApplicationParameterHook(con.CHECK_PASSWORD)
    const dispatch = useDispatch()
    // To show/hide password
    const [password, setPassword] = useState(() => "")
    const [showPassword, setShowPassword] = useState(() => false)

    useEffect(() => {
        return () => {
            dispatch(setApplicationParameter({ id: con.CHECK_PASSWORD, value: con.NOT_STARTED }))
        }
    }, [dispatch])
    

  return (
    <div>

        <h3>{title}</h3>
        <div className="columnParameterBox">
        {passwordStatus === con.OK ? <h4>Contraseña Aceptada</h4> :
        passwordStatus === con.ERROR ? <h4 style={{color: "var(--danger-color)"}}>Contraseña Inválida</h4> :
            <div className="confirmCancelParameterBox">             
                <FormGroup label="Ingrese su Contraseña">                    
                    <InputGroup id="password"   
                        className="input-editing"
                        type={ showPassword ? "text" :"password"}             
                        value={password} 
                        rightElement={<LockEyePasswordButton showPassword={showPassword} setShowPassword={setShowPassword} />}
                        onChange={(e) => {setPassword(e.target.value)}} />
                </FormGroup>
                <button onClick={() => dispatch(checkPassword(password))} disabled={passwordStatus === con.LOADING}>
                            Revisar    
                </button>           
            </div>
            }  
            <h5>{passwordStatus === con.WRONG_CREDENTIALS ? "Contraseña Invalida" : ""}</h5>
              <div className="confirmCancelParameterBox">                  
                <Button text="Eliminar" disabled={passwordStatus !== con.OK} icon="tick" onClick={(e) => deleteAction()} />
                <Button text="Cancelar"  icon="cross" onClick={(e) => cancelAction()} />
              </div>
        </div>

    </div>
  )
}

export default TransactionsDeleteDialog